import {useState} from 'react';
import styles from "./HomeSidebar.module.css"

import { Link } from 'react-router-dom';

import SidebarCard from "../SidebarCard/SidebarCard";

import {AiFillHome, AiFillSetting} from "react-icons/ai"
import {BsFillGrid1X2Fill} from "react-icons/bs"
import {FaUser} from "react-icons/fa"

export default function HomeSidebar({selectedOption}) {
  const [sidebarWidth, setSidebarWidth] = useState(300);
  const [minimisedSidebar, setMinimisedSidebar] = useState(false);

  return (
    <SidebarCard
      sidebarWidth={sidebarWidth}
      setSidebarWidth={setSidebarWidth}
      minimisedSidebar={minimisedSidebar}
      setMinimisedSidebar={setMinimisedSidebar}
     >
        <ul className={styles.sidebarOptions}>
         <li className={selectedOption === "home" ? styles.selected : undefined}><Link to="/"><AiFillHome className={styles.icon} /> Home</Link></li>
         <li className={selectedOption === "allDesigns" ? styles.selected : undefined}><Link to="/allDesigns"><BsFillGrid1X2Fill className={styles.icon} /> All your designs</Link></li>
         <li className={selectedOption === "profile" ? styles.selected : undefined}><Link to="/profile"><FaUser className={styles.icon} /> Account</Link></li>
         <li className={selectedOption === "settings" ? styles.selected : undefined}><Link to="/settings"><AiFillSetting className={styles.icon} /> Settings</Link></li>
       </ul>
    </SidebarCard>
  );
}
